import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { ListComponent } from './chat/list/list.component';
import { RoomComponent } from './chat/room/room.component';
import { ErrorComponent } from '../shared/error/error.component';
import { ChatComponent } from './chat/chat.component';
import { ChangepassComponent } from './changepass/changepass.component';

const cRoutes: Routes = [{
  path: '',
  component: DashboardComponent,
  children: [
    {
      path: 'chat',
      component: ChatComponent,
      children: [
        {
          path: 'list/:type',
          component: ListComponent,
          /*
          children: [
            {
              path: 'room/:id',
              component: RoomComponent
            }
          ]
          */
        },
        {
          path: '',
          redirectTo: 'list/received',
          pathMatch: 'full'
        }
      ]
    },
    {
      path: 'changepassword',
      component: ChangepassComponent
    },
    {
      path: '',
      redirectTo: 'chat',
      pathMatch: 'full'
    },
    {
      path: '**',
      component: ErrorComponent
    }
  ]
}];


@NgModule({
  imports: [
    RouterModule.forChild(
      cRoutes
    )
  ],
  exports: [
    RouterModule
  ]
})
export class DashboardRoutingModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/dashboard-routing.module.ts